import React from 'react';

export default function Divider({ text = 'Ou', className = '' }) {
  return (
    <div className={`grid grid-cols-[1fr_auto_1fr] items-center gap-3 text-slate-400 ${className}`}>
      <span className="h-px w-full bg-slate-200" />
      <span className="px-3 text-[14px] text-slate-500">{text}</span>
      <span className="h-px w-full bg-slate-200" />
    </div>
  );
}

